var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',_vm._g({},_vm.$listeners),[_c('v-expansion-panel-header',[_vm._t("header",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }